import {
  boolean,
  integer,
  jsonb,
  pgTable,
  timestamp,
  uuid,
} from "drizzle-orm/pg-core";
import { z } from "zod";
import { business } from "./businesses";

export const customIntegrationConfigSchema = z.object({
  type: z.literal("custom"),
  url: z.url(),
  secretKey: z.string().optional(),
});

export type CustomIntegrationConfigSchema = z.infer<
  typeof customIntegrationConfigSchema
>;

export const integrationsConfigSchema = z.discriminatedUnion("type", [
  customIntegrationConfigSchema,
  z.object({
    type: z.literal("wix"),
    accessToken: z.string().min(1, "Access token is required"),
    refreshToken: z.string().min(1, "Refresh token is required"),
    instanceId: z.string().min(1, "Instance ID is required"),
  }),
  z.object({
    type: z.literal("shopify"),
    storeUrl: z.string().min(1, "Store URL is required"),
    apiKey: z.string().min(1, "API key is required"),
    blogId: z.string().min(1, "Blog is required"),
    authorName: z.string().min(1, "Author name is required"),
  }),
  z.object({
    type: z.literal("webflow"),
    webflowApiKey: z.string(),
    webflowSiteId: z.string(),
  }),
  z.object({
    type: z.literal("wordpress"),
    blogUrl: z.url(),
    tokenType: z.string(),
    accessToken: z.string(),
    blogId: z.string(),
  }),
  z.object({
    type: z.literal("framer"),
    apiKey: z.string(),
  }),
]);

export type IntegrationsConfigSchema = z.infer<typeof integrationsConfigSchema>;

export const integrations = pgTable("integrations", {
  id: uuid("id").primaryKey().defaultRandom(),
  business_id: integer("business_id")
    .notNull()
    .references(() => business.id, { onDelete: "cascade" }),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
  enabled: boolean("enabled").notNull().default(true),
  config: jsonb("config").notNull().$type<IntegrationsConfigSchema>(),
});
